import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const CrossDockingDetailPage = lazy(
  () => import('@/containers/Views/CrossDocking/CrossDockingDetailPage'),
);
const CrossDockingPage = lazy(
  () => import('@/containers/Views/CrossDocking/CrossDockingPage'),
);

const CrossDockingRouter = (
  <Route path="cross_dockings">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.CrossDockings}
          permissions={EBasicActions.Find}
        >
          <CrossDockingPage />
        </PrivateRoute>
      )}
    />
    <Route
      path=":crossDockingId"
      element={(
        <PrivateRoute
          pageName={EPage.CrossDockings}
          permissions={EBasicActions.Find}
        >
          <CrossDockingDetailPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default CrossDockingRouter;
